var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 60,
    viewBox: "0 0 46 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 5H32.5725C31.54 2.09 28.76 0 25.5 0H20.5C17.24 0 14.46 2.09 13.4275 5H13C6.1075 5 0.5 10.6075 0.5 17.5V47.5C0.5 54.3925 6.1075 60 13 60H33C39.8925 60 45.5 54.3925 45.5 47.5V17.5C45.5 10.6075 39.8925 5 33 5ZM10.5 42.5C7.23 42.485 7.23 37.515 10.5 37.5C13.77 37.515 13.77 42.485 10.5 42.5ZM12.1675 30C11.055 30 10.0075 29.5675 9.2225 28.78L6.7025 26.4025C5.7 25.455 5.6525 23.8725 6.6 22.8675C7.5475 21.8625 9.13 21.8175 10.135 22.765L12.1625 24.68L16.2625 20.705C17.2525 19.745 18.835 19.7675 19.7975 20.76C20.7575 21.75 20.735 23.3325 19.7425 24.295L15.0875 28.8075C14.33 29.5675 13.2825 30 12.17 30H12.1675ZM35.5 42.5H20.5C17.23 42.485 17.2325 37.515 20.5 37.5H35.5C38.77 37.515 38.7675 42.485 35.5 42.5ZM35.5 30H25.5C22.23 29.985 22.2325 25.015 25.5 25H35.5C38.77 25.015 38.7675 29.985 35.5 30Z",
    fill: "#548054"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.f86fbf13276f4d01c256a737c64bd9c8.svg";
export { ForwardRef as ReactComponent };